
export function getAccessToken() {
    let token = JSON.parse(localStorage.getItem('authUser')).token;
    return token;
}